import { WayflyerHostedCapital } from "./pages";

export const WayflyerHostedApplicationApp = () => {
  return <WayflyerHostedCapital />;
};
